import React from 'react'
import { withRouter } from 'react-router'
import { goToTop } from 'react-scrollable-anchor'

const ua = navigator.userAgent
const isIE = ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1

class ScrollToTop extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      if (isIE) {
        goToTop()
      } else {
        window.scrollTo(0, 0)
      }
    }
  }

  render() {
    return this.props.children
  }
}

export default withRouter(ScrollToTop)



// WEBPACK FOOTER //
// ./src/hocs/ScrollToTop.js